module.exports = __webpack_public_path__ + "img/stuttgart-logo-icon.e8cb98fe.png";